// TYPES

import { ReducerAction } from 'store/modules/types';
import { ConsultarCidadaoAutistaRequest, Types } from './types';

export function consultarCidadaoAutistaRequest(
	payload: ConsultarCidadaoAutistaRequest,
): ReducerAction {
	return {
		type: Types.CONSULTAR_CIDADAO_AUTISTA_REQUEST,
		payload,
	};
}

export function consultarCidadaoAutistaSuccess(payload: object): ReducerAction {
	return {
		type: Types.CONSULTAR_CIDADAO_AUTISTA_SUCCESS,
		payload,
	};
}

export function consultarCidadaoAutistaFailure(payload: object): ReducerAction {
	return {
		type: Types.CONSULTAR_CIDADAO_AUTISTA_FAILURE,
		payload,
	};
}

export function consultarCidadaoAutistaClear(): ReducerAction {
	return {
		type: Types.CONSULTAR_CIDADAO_AUTISTA_CLEAR,
		payload: null,
	};
}
